import _ from 'lodash';
import { wealthProApi } from '../../redux/api';

const hoFeesSummaryApiEndpoints = wealthProApi.enhanceEndpoints({})
    .injectEndpoints({
        endpoints: (builder) => ({
            getFeesSummary: builder.query({
                query: ({ userIds = [] }) => _.isEmpty(userIds)
                    ? `api/headofficeadmin/feesSummary`
                    : `api/headofficeadmin/feesSummary?userIds=${_.join(userIds, '&userIds=')}`
            })
        })
    });

export const {
    useGetFeesSummaryQuery,
    useLazyGetFeesSummaryQuery
} = hoFeesSummaryApiEndpoints;